import {isSameDomain} from 'app/core/link/utils/isSameDomain';
import type {Nullable, Undef} from 'app/interface';
import {delegateEvent} from 'app/utils/jqueryNative';

let link: Undef<HTMLAnchorElement>;

export function initSetHref() {
    delegateEvent('click', '[data-href]', function (event) {
        // event.target is element where it was clicked
        // 'this' is an element with [data-href]
        if (!(event.target instanceof Element)) {
            return;
        }

        const targetAsLink = event.target.closest('a');
        const url = this.dataset.href;
        const excluded = this.dataset.hrefExcluded !== undefined || event.target.closest('[data-href-excluded]');
        const prioritized = this.dataset.hrefPrioritize !== undefined;
        const linkTarget: Nullable<LinkTarget> = this.dataset.hrefTarget as Nullable<LinkTarget>;

        if ((!targetAsLink?.getAttribute('href') || prioritized) && !excluded) {
            if (!link) {
                link = document.createElement('a');
                link.setAttribute('hidden', '');
                document.body.appendChild(link);
            }

            link.setAttribute('href', url);
            const targetValue = event.metaKey || event.ctrlKey || linkTarget === LinkTarget.BLANK ? LinkTarget.BLANK : LinkTarget.SELF;
            if (targetValue === LinkTarget.BLANK && isSameDomain(url) === false) {
                link.setAttribute('rel', 'noopener noreferrer');
            }

            link.setAttribute('target', targetValue);
            if (this.dataset.hrefScrollAnchor !== undefined) {
                link.dataset.scrollAnchor = '';
            } else {
                delete link.dataset.scrollAnchor;
            }

            link.click();
        }
    });
}

export enum LinkTarget {
    BLANK = '_blank',
    SELF = '_self',
}
